/*
 * Copyright Deskshare, Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const loadSlice = createSlice({
  name: "app",
  initialState: {
    cartLoading: false,
  },
  reducers: {
    setCartLoading: (state, action: PayloadAction<boolean>) => {
      state.cartLoading = action.payload;
    },
  },
});

export const { setCartLoading } = loadSlice.actions;
export default loadSlice.reducer;
